/**
 * Return the scroll view element set when document is loaded
 */
export default () => window.documentViewer.getScrollViewElement();
